export enum AssetEditorState {
  RawJSONEditor,
  CreateAssetModel,
  SelectFeature,
  EditFeature,
  AddFeature,
}
